
import React, { useEffect, useState } from 'react';
import Icon from '../components/Icon';
import { useNavigate } from 'react-router-dom';

const IconContainer = ({ context, setFormData, formData }) => {
  const [icons, setIcons] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch icons from the backend API
    const fetchIcons = async () => {
      try {
        const response = await fetch(`https://curb-it-backend-91f194a5e08f.herokuapp.com/categories`);
        const data = await response.json();
        const first12Icons = data.slice(0, 12) // Retrieve only the first 12 icons
        setIcons(first12Icons);
      } catch (error) {
        console.error('Error fetching icons:', error);
      }
    };
  
    fetchIcons();
  }, []);


  function handleIconClick(category) {
    if (context === 'create-listing') {
      // Update the icon in the FormDataContext
      setFormData({ ...formData, category: category });
    } else if (context === 'search-listings') {
      navigate(`/get-listings/category/${category}`);
    }
  }


  return (
    <div className="container mx-auto py-8">
      <div className="grid grid-cols-3 gap-4 justify-items-center">
          {icons.map((icon, index) => (
            <Icon key={index} name={icon.icon} onClick={() => handleIconClick(icon.category)} />
          ))}
        </div>
    </div>
  );
};

export default IconContainer;

